import { SxProps, Theme } from '@mui/material';

// Puppeteer prints to 13.333in x 7.5in. In print CSS pixels that maps to 1280 x 720.
export const GAIA_PDF_PAGE_HEIGHT_PX = 720;
const reportHorizontalPadding = 6;
const pdfTopPadding = 5;
const pdfBottomPadding = 4;
const webTopPadding = 12;

type SectionShellOptions = {
  backgroundColor: string;
  pdfExport: boolean;
  webBottomPadding?: number;
  webBorderRadius?: string;
  fullHeightInPdf?: boolean;
  overflow?: 'hidden' | 'visible';
};

type SectionHeadingOptions = {
  backgroundColor: string;
  pdfExport: boolean;
  webBottomPadding?: number;
};

type BodyTextOptions = {
  color: string;
  isMobileModeMd: boolean;
  isMobileModeSm: boolean;
  pdfExport: boolean;
  pdfMarginBottom?: number;
  webMarginBottom?: number;
};

export function getGaiaReportSectionShellSx({
  backgroundColor,
  pdfExport,
  webBottomPadding = 34,
  webBorderRadius = '40px 40px 0 0',
  fullHeightInPdf = true,
  overflow = 'visible',
}: SectionShellOptions): SxProps<Theme> {
  return {
    pt: pdfExport ? pdfTopPadding : webTopPadding,
    pb: pdfExport ? pdfBottomPadding : webBottomPadding,
    pl: reportHorizontalPadding,
    pr: reportHorizontalPadding,
    backgroundColor,
    borderRadius: pdfExport ? 0 : webBorderRadius,
    overflow,
    ...(pdfExport && fullHeightInPdf ? { minHeight: `${GAIA_PDF_PAGE_HEIGHT_PX}px`, boxSizing: 'border-box' } : {}),
  };
}

export function getGaiaReportSectionFrameSx({
  backgroundColor,
  pdfExport,
}: {
  backgroundColor: string;
  pdfExport: boolean;
}): SxProps<Theme> {
  return {
    pb: pdfExport ? pdfBottomPadding : 6,
    backgroundColor,
    borderRadius: pdfExport ? 0 : '40px 40px 0 0',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 1,
    ...(pdfExport ? { minHeight: `${GAIA_PDF_PAGE_HEIGHT_PX}px`, boxSizing: 'border-box' } : {}),
  };
}

export function getGaiaReportSectionHeadingSx({
  backgroundColor,
  pdfExport,
  webBottomPadding = 2,
}: SectionHeadingOptions): SxProps<Theme> {
  return {
    backgroundColor,
    borderRadius: pdfExport ? 0 : '40px 40px 0 0',
    pt: pdfExport ? pdfTopPadding : webTopPadding,
    pb: pdfExport ? 2 : webBottomPadding,
    pl: reportHorizontalPadding,
    pr: reportHorizontalPadding,
    zIndex: 2,
  };
}

export function getGaiaReportSectionContentSx(): SxProps<Theme> {
  return {
    pl: reportHorizontalPadding,
    pr: reportHorizontalPadding,
  };
}

export function getGaiaReportBodyTextSx({
  color,
  isMobileModeMd,
  isMobileModeSm,
  pdfExport,
  pdfMarginBottom = 2,
  webMarginBottom = 8,
}: BodyTextOptions): SxProps<Theme> {
  return {
    color,
    mb: pdfExport ? pdfMarginBottom : webMarginBottom,
    fontSize: isMobileModeSm ? '1rem' : isMobileModeMd ? '1.1rem' : '1.35rem',
  };
}
